import {
    AUTHENTICATING_SALESLOFT_REQUEST, AUTHENTICATING_SALESLOFT_SUCCEDDED, AUTHENTICATING_SALESLOFT_FAILED,
    UPDATING_SALESLOFT_REQUEST, UPDATING_SALESLOFT_SUCCEDDED, UPDATING_SALESLOFT_FAILED,
} from '../actionTypes.jsx';
import axios from 'axios';
import {activatingIntegrationSuccedded, deactivatingIntegrationSuccedded, 
  integrationAuthExpired } from '../integrations';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const SALESLOFT_BASE_URL = `${apiUrl}/api/2.0/integrations/salesloft`

export function authenticateAccount(code){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: SALESLOFT_BASE_URL,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}
  
function authenticatingAccount(){
  return {
    type: AUTHENTICATING_SALESLOFT_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_SALESLOFT_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_SALESLOFT_FAILED,
    payload: error
  }
}

/**
* Update salesloft configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: SALESLOFT_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, 'salesloft'));
      dispatch(updatingConfigurationFailed(error.errors))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_SALESLOFT_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_SALESLOFT_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_SALESLOFT_FAILED,
    payload: error
  }
}